import React, { Component } from 'react'
import { Form, Field } from 'redux-form'
import { Input } from 'components/Input/Input'
import { vRequired } from 'components/Input/Input.validations'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'
import { Textarea } from 'components/Input/Textarea'
import { variableHelpText } from '../../utils/variableHelpText'
import SelectPretty from 'components/Input/SelectPretty'

export default class ForwardCallForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo, numberOptions } = this.props
    const submit = data => onSubmit(node, { extras: data })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          Sends an SMS message. Make sure to specify the 'To' and 'From' mobile numbers.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>
        <Field
          name="from"
          options={numberOptions}
          component={SelectPretty}
          label="From"
          validate={[vRequired]}
        />
        <Field
          label="To"
          name="to"
          component={Input}
          type="text"
          validate={[vRequired]}
          info={variableHelpText}
        />
        <Field
          label="Message"
          name="message"
          component={Textarea}
          type="text"
          display="standard"
          validate={[vRequired]}
          info={variableHelpText}
        />
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/SendSmsMessage/SendSmsMessageForm.jsx